/* eslint-disable max-lines */
// Posturra Muscle Atlas — THIN ADAPTER (Phase 1 canonical migration).
//
// The clinical anatomy data for the modern realistic atlas now lives in the
// single source of truth:  ./anatomyCatalog.json
//
// This module is intentionally a thin adapter: it loads that JSON and re-exports
// the EXACT same public interface the rest of the app already consumes, with
// identical shapes and behavior:
//   REGION_LABELS · MUSCLE_CATALOG · MUSCLE_BY_ID · muscleById ·
//   musclesByRegion · musclesOnView · allRegions · canonicalMuscleId
//
// Phase 1 is migration-only — no new structures, no coordinate/label/maskPath
// changes, no alias expansion. See /app/memory/PRD.md (Iter — Canonical Atlas
// Migration) for the rollback-safe plan and the deep-equality guard.

import anatomyCatalog from "./anatomyCatalog.json";

// ── Public data exports (sourced from the canonical JSON) ───────────────────
export const REGION_LABELS = anatomyCatalog.regionLabels;

export const MUSCLE_CATALOG = anatomyCatalog.catalog;

// Lookup helpers ────────────────────────────────────────────────────────────
export const MUSCLE_BY_ID = MUSCLE_CATALOG.reduce((acc, m) => { acc[m.id] = m; return acc; }, {});

export function muscleById(id) { return MUSCLE_BY_ID[id] || null; }

export function musclesByRegion(region) {
  return MUSCLE_CATALOG.filter((m) => m.region === region);
}

export function musclesOnView(view) {
  return MUSCLE_CATALOG.filter((m) => (m.visibleOn || []).includes(view));
}

export function allRegions() {
  return Object.keys(REGION_LABELS);
}

// Map old/short legacy ids to canonical ids — needed because historic sessions
// stored worked_areas using shorthand like 'upper_trap', 'qL', 'glute_med', etc.
// The mapping is stored canonically in anatomyCatalog.json -> legacyAliases.
const LEGACY_ID_MAP = anatomyCatalog.legacyAliases;

export function canonicalMuscleId(id) {
  if (!id) return id;
  if (MUSCLE_BY_ID[id]) return id;
  const low = String(id).toLowerCase();
  if (MUSCLE_BY_ID[low]) return low;
  return LEGACY_ID_MAP[low] || id;
}
